import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { DatePicker, DataTable } from '@3plearning/react-components';
import cloneDeep from 'lodash/cloneDeep';
import allClassesActions, {
    LIVE_MATHS_ALL_CLASSES_RETRIEVED
} from './all-classes-actions';
import {
    SELECTED_DATE,
    SELECTED_CLASS,
    SELECTED_YEAR_GROUP,
    SELECTED_TEACHER
} from '../../../components/report-filters/filter-constants';
import { activeFiltersPropType } from '../../../components/report-filters/filter-prop-types';
import css from './all-classes.scss';
import activeFiltersActions from '../../../components/report-filters/redux/active-filters/active-filters-actions';
import {
    ALL_CLASSES_TABLE_CONFIG,
    ALL_YEARS_TABLE_CONFIG,
    CLASS_ID,
    CLASS_NAME
} from './all-classes-constants';
import activeFiltersSelectors from '../../../components/report-filters/redux/active-filters/active-filters-selectors';
import { liveMathsLevelPropType } from './all-classes-prop-types';
import TableHeader from '../../../components/table-header/table-header';
import RouteHelper from '../../../helpers/route-helper';
import FilterHelper from '../../../helpers/filter-helper';
import { translateTableLabels } from '../../../helpers/locale-helpers';

/**
 * Displays live maths results for all classes
 */
export class AllClasses extends Component {
    static propTypes = {
        liveMathsData: PropTypes.arrayOf(liveMathsLevelPropType),
        activeFilters: activeFiltersPropType,
        isAdmin: PropTypes.bool,
        updateActiveFilter: PropTypes.func,
        invalidRequest: PropTypes.string,
        liveMathsLevel: PropTypes.number,
        getLiveMathsData: PropTypes.func
    };

    constructor(props) {
        super(props);

        const liveMathsTableConfig = cloneDeep(ALL_CLASSES_TABLE_CONFIG);
        this.isLandingPage = true;
        this.isAllYearsRoute = false;
        this.state = {
            liveMathsTableConfig,
            liveMathsLevelData: null
        };
        this.setRouteType(props, true);
        this.i18n = window.i18n;
    }

    componentDidMount() {
        const { liveMathsData, liveMathsLevel, activeFilters } = this.props;
        if (FilterHelper.shouldLoadAllClasses(activeFilters)) {
            this.getAllClassesLiveMathsData(this.props);
            this.setLiveMathsData(liveMathsData, liveMathsLevel);
        }
    }

    componentWillReceiveProps(newProps) {
        const {
            activeFilters,
            isAdmin,
            invalidRequest,
            updateActiveFilter,
            liveMathsData,
            liveMathsLevel
        } = this.props;
        const {
            activeFilters: newActiveFilters,
            isAdmin: newIsAdmin,
            invalidRequest: newInvalidRequest,
            liveMathsData: newLiveMathsData,
            liveMathsLevel: newLiveMathsLevel
        } = newProps;

        if (
            FilterHelper.shouldReloadAllClasses(activeFilters, newActiveFilters)
        ) {
            this.getAllClassesLiveMathsData(newProps);
        }

        if (
            liveMathsData !== newLiveMathsData ||
            liveMathsLevel !== newLiveMathsLevel
        ) {
            this.setLiveMathsData(newLiveMathsData, newLiveMathsLevel);
        }

        if (activeFilters !== newActiveFilters || isAdmin !== newIsAdmin) {
            this.setRouteType(newProps);
        }

        if (
            invalidRequest !== newInvalidRequest &&
            newInvalidRequest === LIVE_MATHS_ALL_CLASSES_RETRIEVED
        ) {
            if (
                newActiveFilters[SELECTED_DATE].type !==
                DatePicker.THIS_SCHOOL_YEAR
            ) {
                updateActiveFilter(SELECTED_DATE, {
                    type: DatePicker.THIS_SCHOOL_YEAR
                });
            }
        }
    }

    getAllClassesLiveMathsData = (props) => {
        const { getLiveMathsData, activeFilters } = props;
        this.setRouteType(props);
        getLiveMathsData(
            activeFilters[SELECTED_DATE],
            activeFilters[SELECTED_YEAR_GROUP].id,
            activeFilters[SELECTED_TEACHER].id
        );
    };

    setLiveMathsData(allLevelsLiveMathsData, liveMathsLevel) {
        if (allLevelsLiveMathsData) {
            this.setState({
                liveMathsLevelData: [allLevelsLiveMathsData[liveMathsLevel - 1]]
            });
        }
    }

    setRouteType(props, firstLoad) {
        const { isAdmin, activeFilters } = props;
        this.isLandingPage = RouteHelper.isLandingPage(isAdmin, activeFilters);
        this.isAllYearsRoute = RouteHelper.isAllYearsRoute(
            isAdmin,
            activeFilters
        );
        if (!firstLoad) {
            this.setTableConfig();
        }
    }

    setTableConfig = () => {
        let liveMathsTableConfig;
        if (this.isAllYearsRoute) {
            liveMathsTableConfig = cloneDeep(ALL_YEARS_TABLE_CONFIG);
        } else {
            liveMathsTableConfig = cloneDeep(ALL_CLASSES_TABLE_CONFIG);
        }
        const filterKey = this.isAllYearsRoute ? CLASS_ID : CLASS_NAME;
        liveMathsTableConfig.nestedData.cols.find(
            (col) => col.id === filterKey
        ).onClick = this.loadClassPage;

        const translateTransform = true;
        liveMathsTableConfig = translateTableLabels(
            liveMathsTableConfig,
            translateTransform
        );
        this.setState({ liveMathsTableConfig });
    };

    loadClassPage = (selectedClass) => {
        const itemType = this.isAllYearsRoute
            ? SELECTED_YEAR_GROUP
            : SELECTED_CLASS;
        this.props.updateActiveFilter(itemType, {
            id: selectedClass.id,
            name: selectedClass.name
        });
    };

    render() {
        const { liveMathsTableConfig, liveMathsLevelData } = this.state;
        const i18n = window.i18n;
        return (
            <div className={css.component}>
                <div className={css['live-maths-results']}>
                    {this.isLandingPage ? (
                        <h3>{i18n._('Table Header - Live Mathletics')}</h3>
                    ) : (
                        <TableHeader
                            title={i18n._('Table Header - Live Mathletics')}
                        />
                    )}
                    <DataTable
                        data={liveMathsLevelData}
                        config={liveMathsTableConfig}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeFilters: activeFiltersSelectors.selectActiveFilters(state),
        liveMathsData: state.liveMathsAllClasses,
        invalidRequest: state.invalidRequest,
        liveMathsLevel: state.liveMathsLevel,
        isAdmin: state.isAdmin
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getLiveMathsData: allClassesActions.getLiveMathsData,
            updateActiveFilter: activeFiltersActions.updateActiveFilter
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(AllClasses);



// WEBPACK FOOTER //
// ./containers/live-maths/all-classes/all-classes.js